export const getWrapperStyles = ({ columns = 1, disablePortal, customStyles } = {}) => ({
  position: disablePortal ? 'relative' : undefined,
  gridColumn: `span ${columns}`,

  ...customStyles,
});
